<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">采购退货</div>
      <div class="title--button"></div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="purchaseOrderSearch"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 0"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    ></myHtml>
  </div>
</template>
<script>
import { selcetSetting, updateSetting, _debounce } from "@/utils/myUtils";
import projectConfig from "@/core/config";
import { mergeCheckPurchasesOrderDoc } from "@/api/myController/purchase";
import { sysDocExamineConfig_canCheckDocByDocType } from "@/api/myController/system";
export default {
  name: "purchase_return",
  props: {},
  components: {},
  data() {
    return {
      listQuery: {
        customerName: "", // 账户编号
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      // 操作栏数据
      operationTitleData: [],
      // 排序
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      // 操作栏数据
      titleOperationTitleData: [
        {
          name: "基本信息",
          value: "searchString",
          type: "text",
        },
        { name: "搜索", type: "button" },
      ],
      listLoading: false,
      columnType: "columnAll", // columnIndex序号,columnBox复选框
      // 按钮集合
      tableBtnList: ["详情"],
      // 表内容
      list: [],
      // 表头
      titleList: [
        {
          id: 1,
          name: "退货日期",
          value: "basePurchasesChargebackTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 2,
          name: "退货单号", // 必传
          value: "purchasesChargebackDocNumber", // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: "text", // 必传
          selectOptionKey: "", // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: false, // 是否不可编辑，true可编辑，false不可编辑
          color: "#409eff",
          width: 120,
          sortable: true,
        },
        {
          id: 1,
          name: "标题",
          value: "docName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 220,
          sortable: true,
        },
        {
          id: 1,
          name: "全局搜索码",
          value: "globalSearchNumber",
          color: "#1476c3",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 4,
          name: "供应商名称",
          value: "baseSupplierName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 240,
        },
        {
          id: 1,
          name: "供应商简称",
          value: "baseSupplierShortname",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 205,
        },
        {
          id: 3,
          name: "订单状态",
          value: "statusDoc",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "进行中",
              value: 0,
              color: "white",
              backGroundColor: "rgb(79,129,246)",
            },
            {
              label: "已完成",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
            },
            {
              label: "已终止",
              value: 2,
              color: "white",
              backGroundColor: "rgb(220,223,230)",
            },
          ],
          canEdit: false,
          width: 88,
        },
        {
          id: 10,
          name: "审核状态",
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionKey: "",
          selectOptionList: [
            {
              label: "已审核",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未审核",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: false,
          width: 78,
        },
        // {
        //   id: 5,
        //   name: "采购单号",
        //   value: "purchasesOrderDocNumber",
        //   fixedState: false,
        //   isShow: true,
        //   dataType: "text",
        //   canEdit: false,
        //   width: 115,
        // },
        {
          id: 5,
          name: "产品编号",
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          color: "#1476c3",
          canEdit: false,
          width: 115,
        },
        {
          id: 6,
          name: "产品名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 160,
        },
        {
          id: 7,
          name: "产品规格",
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 300,
        },
        {
          id: 0,
          name: "图纸数量",
          value: "valueImgList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 120,
        },
        {
          id: 0,
          name: "附件数量",
          value: "valueFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 80,
        },
        {
          id: 7,
          name: "退货数量",
          value: "baseAmount",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 100,
        },
        {
          id: 15,
          name: "含税单价",
          value: "baseMaterialUnitprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 16,
          name: "未税单价",
          value: "baseMaterialUnitpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 17,
          name: "税率(%)",
          value: "baseTaxRate",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 115,
        },
        {
          id: 18,
          name: "含税总价",
          value: "baseMaterialTotalprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 19,
          name: "未税总价",
          value: "baseMaterialTotalpriceUntaxed",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 115,
        },
        {
          id: 25,
          name: "销售人",
          value: "baseQuotationPersonName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 140,
        },
        {
          id: 27,
          name: "备注",
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          width: 115,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = false;
      this.list = [];
      this.$nextTick(() => {
        this.$refs.myOperate.dragSortShow();
      });
      return;
      pmgtPurchasesOrderDoc_list({
        orderParam: [this.orderParam],
        filter: this.purchaseOrderSearch,
        pmgtPurchasesOrderDocDetailDtoFilter: this.purchaseOrderSearch,
        pageParam: this.listQuery,
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            try {
              for (let i = 1; i <= 50; i++) {
                // 详情
                let name1 = "detail_ext" + i;
                let name2 = "122-ext" + i;
                item[name2] = item[name1];
                // 订单
                let name3 = "main_ext" + i;
                let name4 = "121-ext" + i;
                item[name4] = item[name3];
                // 产品
                let name5 = "product_ext" + i;
                let name6 = "1-ext" + i;
                item[name6] = item[name5];
              }
            } catch (error) {}
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
            try {
              if (item.baseBomVersion) {
                item.baseBomVersionV2 = "V" + item.baseBomVersion;
              } else {
                item.baseBomVersionV2 = "---";
              }
            } catch (error) {}
            item.residueTime = timeInterval(item.baseReceiptDate);
            //
            item.valueFileCount = 0;
            item.valueImgCount = 0;
            item.baseDrawingCount = 0;
            item.baseFileCount = 0;
            try {
              item.valueFileCount = JSON.parse(item.valueFileList).length;
            } catch (error) {
              item.valueFileCount = 0;
            }
            try {
              item.valueImgCount = JSON.parse(item.valueImgList).length;
            } catch (error) {
              item.valueImgCount = 0;
            }
            try {
              item.baseDrawingCount = JSON.parse(item.baseDrawingFile).length;
            } catch (error) {
              item.baseDrawingCount = 0;
            }
            try {
              item.baseFileCount = JSON.parse(item.baseFileList).length;
            } catch (error) {
              item.baseFileCount = 0;
            }
          });
          this.list = res.data.data.dataList;
          this.listQuery.total = res.data.data.totalCount;
        } else {
          this.list = [];
        }
        this.listLoading = false;
        this.$refs.myOperate?.dragSortShow();
      });
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case "":
          break;

        default:
          break;
      }
    },
    // 操作栏点击事件
    operationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();
          break;
        default:
          break;
      }
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case "":
          break;
        default:
          break;
      }
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        case "":
          break;

        default:
          break;
      }
    },
    // 多选
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
    },
    // 重置
    async resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
      justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.spanText {
  color: #1476c3;
  font-size: 14px;
}

.operations {
  float: left;
  width: 200px;
  padding-top: 6px;
}

/*  修改页面样式 */

.title--font {
  text-align: left;
  padding: 10px 0;
}
::v-deep .operation {
  margin-bottom: 10px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}
::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}
::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
.title--button {
  right: 0;
  margin-top: 0.7%;
}
</style>
